module.exports = "<div class=\"select-wrapper\" dbmClickOutside (clickOutside)=\"close()\">\n<div class=\"select_trigger\" (click)=\"toggleMenu()\">\n        <span>{{placeholder}}</span>\n        <span class=\"caret\"></span>\n    </div>\n    <ul class=\"list-options\" [class.active]=\"isMenuToggle\" (click)=\"toggleMenu()\">\n        <li *ngFor=\"let value of listData;index as i\" (click)=\"selectValue(value)\">{{value}}</li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/basic-components/dbm-dropdown/dbm-dropdown.component.html
// module id = 1879
// module chunks = 0